var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamondBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 33 456.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        opacity: .09;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14 {\r\n        fill: #efefef;\r\n      }\r\n\r\n      .cls-3 {\r\n        opacity: .16;\r\n      }\r\n\r\n      .cls-4 {\r\n        opacity: .58;\r\n      }\r\n\r\n      .cls-5 {\r\n        opacity: .51;\r\n      }\r\n\r\n      .cls-6 {\r\n        opacity: .86;\r\n      }\r\n\r\n      .cls-7 {\r\n        opacity: .79;\r\n      }\r\n\r\n      .cls-8 {\r\n        opacity: .72;\r\n      }\r\n\r\n      .cls-9 {\r\n        opacity: .3;\r\n      }\r\n\r\n      .cls-10 {\r\n        opacity: .23;\r\n      }\r\n\r\n      .cls-11 {\r\n        opacity: .44;\r\n      }\r\n\r\n      .cls-12 {\r\n        opacity: .37;\r\n      }\r\n\r\n      .cls-13 {\r\n        opacity: .65;\r\n      }\r\n\r\n      .cls-14 {\r\n        opacity: .93;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 2.32,
    y: 431.26,
    width: 7.35,
    height: 7.35,
    transform: "translate(-305.79 131.63) rotate(-45)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 2.32,
    y: 398.36,
    width: 7.35,
    height: 7.35,
    transform: "translate(-282.52 121.99) rotate(-45)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 2.32,
    y: 365.45,
    width: 7.35,
    height: 7.35,
    transform: "translate(-259.26 112.36) rotate(-45)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 2.32,
    y: 332.55,
    width: 7.35,
    height: 7.35,
    transform: "translate(-235.99 102.72) rotate(-45)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 2.32,
    y: 299.65,
    width: 7.35,
    height: 7.35,
    transform: "translate(-212.73 93.08) rotate(-45)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 2.32,
    y: 266.75,
    width: 7.35,
    height: 7.35,
    transform: "translate(-189.46 83.45) rotate(-45)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 2.32,
    y: 233.85,
    width: 7.35,
    height: 7.35,
    transform: "translate(-166.2 73.81) rotate(-45)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 2.32,
    y: 200.95,
    width: 7.35,
    height: 7.35,
    transform: "translate(-142.93 64.17) rotate(-45)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 2.32,
    y: 168.04,
    width: 7.35,
    height: 7.35,
    transform: "translate(-119.67 54.54) rotate(-45)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 2.32,
    y: 135.14,
    width: 7.35,
    height: 7.35,
    transform: "translate(-96.4 44.9) rotate(-45)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 2.32,
    y: 102.24,
    width: 7.35,
    height: 7.35,
    transform: "translate(-73.14 35.26) rotate(-45)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 2.32,
    y: 69.34,
    width: 7.35,
    height: 7.35,
    transform: "translate(-49.87 25.63) rotate(-45)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 2.32,
    y: 36.44,
    width: 7.35,
    height: 7.35,
    transform: "translate(-26.61 15.99) rotate(-45)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 2.32,
    y: 3.54,
    width: 7.35,
    height: 7.35,
    transform: "translate(-3.34 6.35) rotate(-45)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamondBackground);
export default __webpack_public_path__ + "static/media/diamond-background.d0dc1d3a4c56df771be959cca0fdee2d.svg";
export { ForwardRef as ReactComponent };